import React, { useState } from 'react';
import {
  Button, CircularProgress, FormControl, Grid, InputLabel, MenuItem, Select,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import Alert from '@mui/material/Alert';

import Service from '../../api/service';
import BalanceResultContainer from './BalanceResultContainer';
import Center from '../../components/Center';
import InputMask from '../../components/common/InputMask';

const useStyles = makeStyles(() => ({
  infos: {
    margin: '25px 15px',
  },
  container: {
    display: 'flex',
    width: '100%',
    maxWidth: '600px',
    margin: '0 auto',
  },
}));

export default function SimulationPage() {
  const classes = useStyles();

  const [cpf, setCpf] = useState('');
  const [installment, setInstallment] = useState(5);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState({});

  const service = new Service();

  const installmentsRange = [1, 2, 3, 4, 5];
  const onInstallmentChange = (e) => {
    setInstallment(e.target.value);
  };

  const handleCpfChange = (e) => {
    setCpf(e.target.value || '');
  };

  const onClickGetBalance = () => {
    setLoading(true);
    setError(false);
    setResult({});

    service.simulation(cpf, installment, (ok) => {
      setResult(ok);
      setError(false);
      setLoading(false);
    }, (fail) => {
      setError(fail);
      setLoading(false);
    });
  };

  return (
    <>
      <div className={classes.container}>
        <Grid container spacing={5}>
          <Grid item xs={12}>
            <InputMask
              mask="000.000.000-00"
              value={cpf || ''}
              onChange={handleCpfChange}
              onInput={handleCpfChange}
              required
              label="CPF"
              variant="outlined"
              fullWidth
            />
          </Grid>

          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel id="installment-select-label">Parcelas</InputLabel>
              <Select
                id="installment-select"
                labelId="installment-select-label"
                label="Parcelas"
                value={installment}
                onChange={onInstallmentChange}
                displayEmpty
              >
                {
                  installmentsRange.map((i) => (
                    <MenuItem key={i} value={i}>
                      {`${i} Parcelas`}
                    </MenuItem>
                  ))
                }
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <Button color="primary" variant="contained" onClick={() => onClickGetBalance()}>
              Ver Saldo
            </Button>
            <div className={classes.infos}>
              {
                loading && (
                  <Center>
                    <CircularProgress />
                  </Center>
                )
              }

              {
                error && (
                  <Alert severity="error">{error.message}</Alert>
                )
              }
            </div>

            <BalanceResultContainer result={result} error={!!error} loading={loading} />
          </Grid>
        </Grid>
      </div>
    </>
  );
}

/* <MaskedStyledInput
    mask='000.000.000-00'
    unmask={true}
    onAccept={
        (value, mask) => console.log(value)
    }
    placeholder='Insira o CPF para simular'
/> */
